import { SiJavascript, SiHtml5 } from "react-icons/si";
import { useState } from "react";
const Skills = () => {
  const [state] = useState([
    {
      id: 1,
      name: "javascript",
      image: "./images/javascript.png",
      class: "bg-orange-100",
    },
    {
      id: 2,
      name: "react js",
      image: "./images/react.png",
      class: "bg-blue-50",
    },
    {
      id: 3,
      name: "next js",
      image: "./images/next-js.png",
      class: "bg-gray-100",
    },
    { id: 4, name: "HTML", image: "./images/html.png", class: "bg-orange-100" },
    { id: 5, name: "CSS", image: "./images/css.png", class: "bg-blue-100" },
    { id: 6, name: "vue js", image: "./images/vue.png", class: "bg-green-200" },
    {
      id: 9,
      name: "typeScript",
      image: "./images/typescript.png",
      class: "bg-blue-100",
    },
    { id: 10, name: "sass", image: "./images/sass.png", class: "bg-rose-100" },
    {
      id: 11,
      name: "redux",
      image: "./images/redux.png",
      class: "bg-indigo-200",
    },
    {
      id: 12,
      name: "graphQL",
      image: "./images/graphql.png",
      class: "bg-rose-200",
    },
    { id: 14, name: "git", image: "./images/git.png", class: "bg-rose-100" },
    {
      id: 15,
      name: "node js",
      image: "./images/node.png",
      class: "bg-green-200",
    },
    {
      id: 16,
      name: "mongodb",
      image: "./images/mongodb.png",
      class: "bg-green-200",
    },
    {
      id: 17,
      name: "styled components",
      image: "./images/styled.png",
      class: "bg-orange-200",
    },
    {
      id: 18,
      name: "tailwindcss",
      image: "./images/tailwind.png",
      class: "bg-teal-100",
    },
    {
      id: 19,
      name: "PHP",
      image: "./images/php.png",
      class: "bg-blue-100",
    },
    {
      id: 20,
      name: "MySQL",
      image: "./images/mysql.png",
      class: "bg-blue-100",
    },
    {
      id: 21,
      name: "bootstrap",
      image: "./images/bootstrap.png",
      class: "bg-violet-100",
    },
    {
      id: 22,
      name: "express js",
      image: "./images/express.png",
      class: "bg-gray-200",
    },
    {
      id: 23,
      name: "websocket",
      image: "./images/websocket.png",
      class: "bg-gray-200",
    },
    {
      id: 24,
      name: "github, CI CD",
      image: "./images/github-actions.png",
      class: "bg-gray-700",
    },
    {
      id: 25,
      name: "solidity",
      image: "./images/Solidity1.png",
      class: "bg-gray-200",
    },
  ]);
  return (
    <div className="py-[90px] relative before:absolute before:top-0 before:left-0 before:w-[50%] before:bg-teal-50 dark:before:bg-gradient-to-r dark:before:from-gray-800 dark:before:to-gray-900 before:h-full after:absolute after:top-0 after:right-0 after:w-[50%] after:bg-gray-100 dark:after:bg-gray-900 after:h-full before:-z-10 after:-z-10">
      <div className="container-block z-50">
        <div className="flex flex-wrap items-center -mx-5">
          <div className="w-full md:w-6/12 p-5">
            <div className="flex flex-wrap -mx-3">
              {state.map((skill) => (
                <div className="w-4/12 lg:w-3/12 p-3" key={skill.id}>
                  <div
                    className={`w-[60px] h-[60px] rounded-full ${skill.class} p-3 m-auto cursor-pointer`}
                  >
                    <img
                      src={skill.image}
                      className="w-full h-full object-cover"
                      alt=""
                    />
                  </div>
                  <span className="block font-medium text-sm mt-2 text-center dark:text-white capitalize">
                    {skill.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="w-full md:w-6/12 py-5 pr-5 pl-5 md:pl-10">
            <h1 className="text-4xl leading-[45px] font-bold text-black dark:text-white">
              Having Smart <span className="text-teal-900">Skills</span>, in
              Computer Programming
            </h1>
            <p className="mt-5 text-base text-gray-900 leading-[27px] dark:text-white">
              I have 7+ years of programming experiance in the mentioned
              computer languages, and I'm most experiance in JavaScript
              frameworks and libraries, I have created many projects in React
              js, Redux, Express and MongoDB.
            </p>
            <div className="mt-5 flex items-center">
              <span className="text-6xl font-bold text-teal-700">7+</span>
              <span className="block text-base font-semibold ml-3 dark:text-white">
                Years of Experiance
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
